// this is a static singleton object for several defaulting use cases in react components
// using this instead of inline {} can help reducing rerenders or unintented hooks triggers
export const EMPTY_OBJECT = {};
